export function splitAssets(total: number, clientPercent: number) {
  const clientAmount = Math.round((total * clientPercent) / 100);
  const partnerAmount = total - clientAmount;
  return { clientAmount, partnerAmount };
}

export function findPartnerLinkedSource(
  partnerSelfFunding: Record<string, SelfFundingSource> | undefined,
  groupId: string,
): [string, SelfFundingSource] | undefined {
  if (!partnerSelfFunding) return undefined;
  return Object.entries(partnerSelfFunding).find(
    ([, ps]) => ps.fundingSourceGroupId === groupId,
  );
}
